module.exports = {
      id: "step index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#step index-usage",
      toString: function () {
        return this.url;
      }
    }